import Logo from '../../assets/ic-white.png'
import { IoMail } from "react-icons/io5";

const Subscribe = () => {

    return (
        <div className=" bg-tripstore-black/80 py-6 text-white">
            <div className=" container">
                <div className=" flex flex-col md:flex-row gap-4 *:w-full">
                    <div className="">
                        <img src={Logo} className=' h-[80px] m-auto md:m-0' alt="" />
                    </div>
                    <div className=" text-center md:text-left">
                        <div className=" font-semibold">NEW TO TRIPSTORE?</div>
                        <div className=" text-sm mb-4">Subscribe to our newsletter to get latest offers</div>
                        <form className=" flex flex-col gap-2" action="">
                            <div className=" relative w-full md:w-auto">
                                <input className=" pl-8 w-full px-4 py-2" type="email" name="" id="" placeholder="Enter E-mail Address" />
                                <span className=" absolute left-2 top-[50%] -translate-y-[50%] text-lg text-gray-500"><IoMail /></span>
                            </div>
                            <button className=" text-tripstore-black w-full md:w-auto bg-white/80 hover:bg-white">Subscribe</button>
                        </form>
                    </div>
                    <div className=""></div>
                </div>
            </div>
        </div>
    )
}

export default Subscribe